export enum QuantityModificationActions {
  add = 'add',
  subtract = 'subtract',
}
